//export const baseURL = "http://192.168.0.14:5001";
//export const baseURL = "http://localhost:5001";
//export const baseURL = "http://apitunnel.loca.lt";//
//export const baseURL = "https://dev.gentroo.com:25697"; //ezridetest 
//export const baseURL = "https://dev.gentroo.com:25699"; //ezrideqa
//export const baseURL = "https://dev.gentroo.com:25696"; //ezridedev
export const baseURL = "https://ezride.azurewebsites.net"; //prod
export const placesBaseURL = 'https://maps.googleapis.com/maps/api/place';
export const locationTrackingTaskName = 'location-tracking';